/**
 * Helper per i template Rebuy.
 *
 * I template Rebuy sono Vue compilati con `with(this)`: un identificatore che
 * non esiste sull'istanza ricade sullo scope globale. E' cosi' che la loro
 * documentazione intende "any globally accessible functions", ed e' il motivo
 * per cui questa funzione sta su window e non dentro il template.
 *
 * Fa la stessa cosa dello snippet Liquid lar-title-no-vendor, ma a runtime:
 * toglie il marchio dal titolo quando il titolo comincia davvero col marchio.
 * Sul catalogo L'Arcolaio il vendor e' il prefisso esatto del titolo nel
 * 99,7% dei casi (verificato su 2.500 prodotti attivi), ma il controllo si fa
 * lo stesso: un titolo che non comincia col marchio esce intatto.
 */
(function () {
  function ripulisci(testo) {
    return String(testo == null ? '' : testo).replace(/_/g, ' ').trim();
  }

  window.larTitoloSenzaMarca = function (product) {
    if (!product) return '';

    var titolo = ripulisci(product.title);
    var marchio = ripulisci(product.vendor);
    if (!marchio || !titolo) return titolo;

    if (titolo.toLowerCase().indexOf(marchio.toLowerCase()) !== 0) {
      return titolo;
    }

    var resto = titolo.slice(marchio.length).trim();

    // via anche il trattino di raccordo, se il titolo ne aveva uno
    resto = resto.replace(/^[-–|]\s*/, '');

    // se il titolo era solo il marchio, meglio tenerlo che restare vuoti
    return resto || titolo;
  };
})();
